module.exports = __webpack_public_path__ + "img/slick_left_thin_white.3225dfec.svg";